export default __webpack_public_path__ + "static/media/015-frying pan.f27bdb2b.svg";